import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

function PaymentsCancel() {
  const navigate = useNavigate();

  return (
    <div className="pt-10 md:pt-0 text-white relative">
      <div className="max-w-xl mx-auto mt-16 p-8 bg-white/10 border border-white/10 rounded-2xl backdrop-blur-md text-center">
        <div className="flex justify-center mb-4">
          <XCircle className="w-12 h-12 text-yellow-300" />
        </div>
        <p className="text-xl font-semibold mb-2">Payment cancelled</p>
        <p className="text-gray-300 text-sm mb-4">
          Your subscription has not been changed. If this was a mistake, you can
          start the checkout again from the payments page.
        </p>
        <button
          onClick={() => navigate('/payments')}
          className="px-4 py-2 rounded-xl bg-white/10 hover:bg-[#AF9B8A]/20 transition"
        >
          Back to payments
        </button>
      </div>
    </div>
  );
}

export default PaymentsCancel;
